<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">
            <span>Hasta Listesi</span>
        </div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col class="margin-bottom-10" :span="24">
                <el-radio-group size="mini" v-on:change="handleChange($event)" v-model="radio"
                                fill="#E5F5F9"
                                text-color="gray">

                    <el-badge :value="tamamlanan"
                              class="item tamamlanan">
                        <el-radio-button label="1">
                            <i class="mdi mdi-account mdi-18px" style="color: #13ce66; margin-right: 5px"></i>
                            <span style="color: #13ce66" class="durum">Tamamlanan</span>
                        </el-radio-button>
                    </el-badge>
                    <el-badge :value="islemde" class="item islemde">
                        <el-radio-button label="2">
                            <i class="mdi mdi-account mdi-18px" style="color: #00bcd0; margin-right: 5px"></i>
                            <span style="color: #00bcd0" class="durum">İşlemde</span>
                        </el-radio-button>
                    </el-badge>
                    <el-badge :value="pasif" class="item silinen">
                        <el-radio-button label="0">
                            <i class="mdi mdi-account mdi-18px" style="color: #ec205f; margin-right: 5px"></i>
                            <span style="color: #ec205f" class="durum">Silinen</span>
                        </el-radio-button>
                    </el-badge>
                </el-radio-group>
                <div class="aciklamaListesi">
                    <ul>
                        <li class="renk-duzenle"><i class="el-icon-edit"></i> Düzenle</li>
                        <li class="renk-tamamlandi"><i class="mdi mdi-check"></i> Tamamla</li>
                        <li class="renk-silinen"><i class="mdi mdi-close"></i> Sil</li>
                    </ul>
                </div>
            </el-col>
            <el-table
                    :data="tumHastaListesi"
                    ref="filterTable"
                    border
                    stripe
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        sortable
                        label="Hasta ID"
                        prop="oHastaId"
                        width="110">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="adSoyad"
                        label="İsim Soyisim"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="T.C. No / Dosya No / Protokol No"
                        width="250">
                    <template slot-scope="scope">
                        {{scope.row.bilgi}}
                        <el-tooltip :content='scope.row.bilgiAdi' :open-delay="200" placement="left">
                            <i style="color: #00bcd0;float: right" class="mdi mdi-information mdi-24px"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Cinsiyet"
                        width="80">
                    <template slot-scope="scope">
                        <el-tooltip :content='scope.row.cinsiyet' :open-delay="200" placement="bottom">
                            <i v-if="scope.row.cinsiyet === 'Kadın'" style="color: #ec205f"
                               class="mdi mdi-human-female mdi-24px"></i>
                            <i v-else style="color: #0075c3" class="mdi mdi-human-male mdi-24px"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="yas"
                        label="Yaş"
                        width="80">
                </el-table-column>
                <el-table-column
                        sortable
                        prop="kayitTarihi"
                        label="Kayıt Tarihi"
                        width="200">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="250">
                    <template slot="header" slot-scope="scope">
                        <el-input clearable v-on:clear="clearable" v-model="search" v-on:input="searchMethod"
                                  placeholder="Ara" size="mini"></el-input>
                    </template>
                    <template slot-scope="scope">
                        <el-tooltip content='Hasta Detay' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #00bcd0"
                                       class="buttonEdit"
                                       icon="el-icon-user" type="text"
                                       v-on:click="hastaDetayOrtopedi(scope.row.oHastaId)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2' || selectIcon === '1'"  content='Hasta Güncelleme' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer"
                                       class="buttonEdit"
                                       icon="el-icon-edit" type="text"
                                       v-on:click="routeOrtopedi('Ortopedi Hasta Guncelleme',scope.row.oHastaId)"></el-button>
<!--                            <el-button style="cursor: pointer"-->
<!--                                       class="buttonEdit"-->
<!--                                       icon="el-icon-edit" type="text"-->
<!--                                       v-on:click="hastaGuncellemeOrtopedi(scope.row.oHastaId)"></el-button>-->
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2'" content='Tamamla' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #13ce66"
                                       class="buttonEdit"
                                       icon="mdi mdi-check" type="text"
                                       v-on:click="handleCommand('1',scope.row,scope.$index)"></el-button>
                        </el-tooltip>
                        <el-tooltip v-if="selectIcon === '2'" content='Sil' :open-delay="200"
                                    placement="bottom">
                            <el-button style="cursor: pointer; color: #ec205f"
                                       class="buttonEdit"
                                       icon="mdi mdi-close" type="text"
                                       v-on:click="handleCommand('0',scope.row,scope.$index)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    class="margin-top-20"
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.haberler.liste.uyari")'
                :visible.sync="durumChangeDialog"
                width="30%"
                center>
            <span>"{{selection.adSoyad}}" hasta durumunu değiştirmek istediğinize emin misiniz?</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="hastaDurumChange(selection,selectionIndex,tumHastaListesi,durum), durumChangeDialog = false"></el-button>
                    <el-button size="mini" type="danger" icon="el-icon-close"
                               @click="durumChangeDialog = false"></el-button>
                </span>
        </el-dialog>

        <ortopedi-hasta-detay v-if="hastaDetayVisible" :userdataOrtopediHastaDetay="userdataOrtopediHastaDetay" :dialogvisible.sync="hastaDetayVisible"> </ortopedi-hasta-detay>



    </div>
</template>

<script>

    import notification from '../../../notification'
    import hastaOrtopediService from "../../../WSProvider/HastaOrtopediService";
    import OrtopediHastaDetay from "../../../components/OrtopediHastaDetay";

    export default {
        name: "OrtopediHastaListesi",
        components: {
            OrtopediHastaDetay
        },
        mounted() {
            this.getHastaCount();
            this.getHastaListesi()
        },
        data() {
            return {
                reddedilen: '',
                tamamlanan: '',
                onaybekliyor: '',
                islemde: '',
                pasif: '',
                page: 0,
                sizes: 20,
                postPage: 0,
                total: null,
                durumChangeDialog: false,
                hastaGuncellemeVisible: false,
                hastaDetayVisible: false,
                userdataOrtopediHasta:{},
                userdataOrtopediHastaDetay:{},
                selectIcon: this.$store.state.hastaListDurum,
                radio: this.$store.state.hastaListDurum,
                root: false,
                yetkili: false,
                search: '',
                selection: '',
                selectionIndex: '',
                durum: '',
                tumHastaListesi: [],
            }
        },
        methods: {
            hastaDetayOrtopedi(gelenId) {
                this.userdataOrtopediHastaDetay=gelenId;
                this.hastaDetayVisible=true;
            },
            getHastaCount() {
                hastaOrtopediService.hastaOrtopediCountPanel().then((response) => {
                    if (response.status === 200) {
                        if (response.tamamlanan.count !== 0) this.tamamlanan = response.tamamlanan.count;
                        if (response.islemde.count !== 0) this.islemde = response.islemde.count;
                        if (response.pasif.count !== 0) this.pasif = response.pasif.count;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            clearable() {
                this.tumHastaListesi = [];
                this.getHastaListesi();
            },
            searchMethod(val) {
                if (val !== '') {
                    var dizi = [];
                    hastaOrtopediService.hastaOrtopediSearch(val,this.selectIcon).then((response) => {
                        if (response.status === 200) {
                            response.data.forEach(function (e) {
                                dizi.push(e);
                            });
                            this.tumHastaListesi = dizi;
                        } else notification.Status(response.status, this)
                    })
                } else this.clearable();
            },
            handleSizeChange(val) {
                this.sizes = val;
                this.getHastaListesi();
            },
            hastaCount() {
                hastaOrtopediService.hastaOrtopediCount(this.selectIcon).then((response) => {
                    if (response.status === 200) {
                        this.total = parseInt(response.data);
                    }
                });
            },
            handleCommand(durum, row, index) {
                this.selection = row;
                this.selectionIndex = index;
                this.durum = durum;
                this.durumChangeDialog = true;
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getHastaListesi();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.hastaCount();
                this.getHastaListesi();
            },
            getHastaListesi() {
                hastaOrtopediService.hastaOrtopediList(this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.tumHastaListesi = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });

            },
            hastaDurumChange(selection, index, list, durum) {
                hastaOrtopediService.hastaOrtopediDurumGuncelle(selection.oHastaId, durum).then((response) => {
                    if (response.status === 200) {
                        this.getHastaCount();
                        this.getHastaListesi()
                        notification.Status("success", this, "Durum değişikliği başarılı..");
                        list.splice(index, 1);
                    }
                })
            },
            routeOrtopedi(title, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope);
                }
                var obj = tabList.find(data => data.title === title);
                var name = linkTemizle(title.replace(" ", ""))
                if (obj === undefined) {
                    tabList.push({
                        title: title,
                        name: name,
                        contentName: name
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', name);
                } else {
                    this.$store.commit('changeActiveTabs', name);
                }
            },
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>
<style lang="scss" scoped>
    .durum {
        position: relative;
        bottom: 3px;
    }

    .refresh {
        color: #fff;
        float: right;
        padding: 0 !important;
        transition: all 0.5s;

    }

    .refresh:hover {
        transform: scale(1.5, 1.5);
    }

    .el-pagination {
        float: right;
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }

    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 5px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .reddedilen .el-badge__content {
        background-color: #af0800;
        z-index: 1;
        right: 20px;
    }

    .onay .el-badge__content {
        background-color: #f7ba2a;
        z-index: 1;
        right: 20px;
    }

    .islemde .el-badge__content {
        background-color: #00bcd0;
        z-index: 1;
        right: 20px;
    }

    .silinen .el-badge__content {
        background-color: #ec205f;
        z-index: 1;
        right: 20px;
    }

    .randevu .el-badge__content {
        background-color: #6a3ab0;
        z-index: 1;
        right: 20px;
    }

    .doktoronay .el-badge__content {
        background-color: #f2de59;
        z-index: 1;
        right: 20px;
    }

    .uretim .el-badge__content {
        background-color: #ff9632;
        z-index: 1;
        right: 20px;
    }

    .sinterleme .el-badge__content {
        background-color: #f43131;
        z-index: 1;
        right: 20px;
    }

    .polisaj .el-badge__content {
        background-color: #f43131;
        z-index: 1;
        right: 20px;
    }

    .doktoronay2 .el-badge__content {
        background-color: #a027a8;
        z-index: 1;
        right: 20px;
    }

    .depo .el-badge__content {
        background-color: #0075c3;
        z-index: 1;
        right: 20px;
    }

    .kargo .el-badge__content {
        background-color: rgba(0, 117, 195, 0.41);
        z-index: 1;
        right: 20px;
    }

    .tamamlanan .el-badge__content {
        background-color: #13ce66;
        z-index: 1;
        right: 20px;
    }

    .hatali .el-badge__content {
        background-color: black;
        z-index: 1;
        right: 20px;
    }

    .not:hover {
        cursor: pointer;
    }

</style>
